var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dasharea"},[_c('router-view')],1),_c('Navbar',{attrs:{"showBrand":false,"navbarBottom":true,"showLogout":false,"items":_vm.sidebarItems,"replaceInsteadOfPush":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }